import React__default, { useState, useEffect } from 'react';
import Stack from '../../../Stack/Stack.js';
import styles from '../../Table.module.scss.js';
import Typography from '../../../Typography/Typography.js';
import ButtonIcon from '../../../../Forms/ButtonIcon/ButtonIcon.js';
import Checkbox from '../../../../Forms/Checkbox/Checkbox.js';
import { InView } from 'react-intersection-observer';
import classNames from 'classnames';

/* eslint-disable @typescript-eslint/no-explicit-any */
const generateUID = () => {
    const UT = new Date().valueOf();
    const Salt = Math.floor(Math.random() * 100000);
    const UID = `${UT}${Salt}`;
    return UID;
};
const TableRow = ({ row, alignments, keys, isSelectable = false, isChecked = false, 
/*   isOpen = false,
isVisible = false, */
typographyTag = 'textdefault', depth = 0, indentation = 10, virtualized = false, hoverRow = true, allowDoubleClick = false, pointerCursor = false, onRowClick, onRowDoubleClick, onRowMouseOver, onRowMouseOut, onRowRightClick, onRowCheck, }) => {
    const [isExpanded, setIsExpanded] = useState(row.isExpanded ? row.isExpanded : false);
    const [isDisabled, setIsDisabled] = useState(row.isDisabled ? row.isDisabled : false);
    const [isClickable, setIsClickable] = useState(row.isClickable ? row.isClickable : true);
    useEffect(() => {
        setIsExpanded(row.isExpanded ? row.isExpanded : false);
    }, [row.isExpanded]);
    const filterObjectByKeys = (obj, keysArray) => {
        return keysArray.reduce((acc, key) => {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    };
    let clickTimeoutId = null;
    const handleClick = (event) => {
        if (!allowDoubleClick) {
            if (onRowClick) {
                onRowClick(row, event);
            }
        }
        else {
            if (clickTimeoutId !== null) {
                // Double click
                clearTimeout(clickTimeoutId);
                clickTimeoutId = null;
                if (onRowDoubleClick) {
                    if (window.getSelection) {
                        window.getSelection()?.removeAllRanges();
                    }
                    onRowDoubleClick(row, event);
                }
            }
            else {
                // Single click
                clickTimeoutId = setTimeout(() => {
                    clickTimeoutId = null;
                    isClickable && setIsExpanded(!isExpanded);
                    if (onRowClick) {
                        onRowClick(row, event);
                    }
                }, 200);
            }
        }
    };
    /*   const handleDoubleClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
      if (onRowDoubleClick) {
        onRowDoubleClick(row, event);
      }
    }; */
    const handleMouseOver = (event) => {
        /* setIsHovered(true); */
        if (onRowMouseOver) {
            onRowMouseOver(row, event);
        }
    };
    const handleMouseOut = (event) => {
        /* setIsHovered(false); */
        if (onRowMouseOut) {
            onRowMouseOut(row, event);
        }
    };
    const handleRightClick = (event) => {
        if (onRowRightClick) {
            event.preventDefault();
            onRowRightClick(row, event);
        }
    };
    const handleCheck = (event) => {
        event.preventDefault();
        if (onRowCheck) {
            onRowCheck(row.id, event.target.checked);
        }
        event.stopPropagation();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let filteredObject = row.data;
    if (keys && keys.length > 0) {
        filteredObject = filterObjectByKeys(row.data, keys);
    }
    const Cell = ({ row, idx, cell }) => {
        /*  const ClonedElement = React.cloneElement(cell, {
          key: `RF_${idx}_${generateUID()}`,
        }); */
        return (React__default.createElement(React__default.Fragment, { key: `ReactFrag_${idx}_${generateUID()}` }, row.children && row.children.length > 0 && idx === 0 ? (React__default.createElement(Stack, { direction: "row" },
            React__default.createElement(Stack, { direction: "row" },
                React__default.createElement("div", { style: { width: 12 }, key: `icon_${idx}` },
                    React__default.createElement(ButtonIcon, { size: "extra-small", icon: isExpanded ? 'IconCaretDown' : 'IconCaretRight', hoverType: "none", boxSize: 0 })),
                React__default.createElement(React__default.Fragment, null, cell)))) : (React__default.createElement("div", { style: { marginLeft: idx === 0 ? indentation : 0 }, key: `content_${idx}` },
            React__default.createElement(React__default.Fragment, null, cell)))));
    };
    const Tr = () => {
        return (React__default.createElement("tr", { onClick: handleClick, onContextMenu: handleRightClick, 
            /*  onDoubleClick={handleDoubleClick}  //handled in single click event */
            onMouseEnter: handleMouseOver, onMouseLeave: handleMouseOut, className: classNames(isChecked && styles.checked, isDisabled && styles.disabled, !hoverRow && styles.NoHover), key: `${generateUID()}`, style: { cursor: pointerCursor ? 'pointer' : 'auto' } },
            isSelectable ? (React__default.createElement("td", null, row.isSelectable !== false && (React__default.createElement(Checkbox, { isChecked: isChecked, onChange: handleCheck })))) : null,
            Object.values(filteredObject).map((cell, idx) => (React__default.createElement("td", { key: `${idx}_${generateUID()}`, style: { textAlign: alignments[idx] } },
                React__default.createElement("div", { style: { marginLeft: idx === 0 ? depth : 0 } },
                    React__default.createElement(Typography, { tag: typographyTag },
                        React__default.createElement(Cell, { row: row, cell: cell, idx: idx }))))))));
    };
    const TrVirtualized = () => {
        return (React__default.createElement(InView, null, ({ inView, ref }) => (React__default.createElement("tr", { ref: ref, 
            /*  style={{ backgroundColor: isHovered ? 'lightgray' : 'white' }} */
            onClick: handleClick, onContextMenu: handleRightClick, 
            /*    onDoubleClick={handleDoubleClick} */
            onMouseEnter: handleMouseOver, onMouseLeave: handleMouseOut, className: isChecked ? styles.checked : '', style: { cursor: pointerCursor ? 'pointer' : 'auto' } },
            isSelectable ? (React__default.createElement("td", null, row.isSelectable !== false && (React__default.createElement(Checkbox, { isChecked: isChecked, onChange: handleCheck })))) : null,
            Object.values(filteredObject).map((cell, idx) => (React__default.createElement("td", { key: `${idx}_${generateUID()}`, style: { textAlign: alignments[idx] } },
                React__default.createElement("div", { style: {
                        marginLeft: idx === 0 ? depth : 0,
                    }, key: `dv_${idx}_${generateUID()}` },
                    React__default.createElement(Typography, { tag: typographyTag, key: `T_${idx}_${generateUID()}` },
                        React__default.createElement("span", null, " "),
                        inView && (React__default.createElement(Cell, { row: row, cell: cell, idx: idx, key: `Cell_${idx}_${generateUID()}` })))))))))));
    };
    return (React__default.createElement(React__default.Fragment, null,
        !row.isHidden && (virtualized ? React__default.createElement(TrVirtualized, null) : React__default.createElement(Tr, null)),
        isExpanded &&
            row.children?.map((childRow, index) => (React__default.createElement(TableRow, { key: `TR_${index}_${generateUID()}`, alignments: alignments, keys: keys, typographyTag: typographyTag, isSelectable: isSelectable, isChecked: isChecked, row: childRow, depth: depth + indentation, virtualized: virtualized, hoverRow: hoverRow, allowDoubleClick: allowDoubleClick, pointerCursor: pointerCursor, onRowClick: onRowClick, onRowRightClick: onRowRightClick, onRowDoubleClick: onRowDoubleClick, onRowMouseOver: onRowMouseOver, onRowMouseOut: onRowMouseOut, onRowCheck: onRowCheck })))));
};

export { TableRow as default };
//# sourceMappingURL=TableRow.js.map
